import * as React from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Divider from '@mui/material/Divider';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import ListItemText from '@mui/material/ListItemText';
import Typography from '@mui/material/Typography';
import {colorPaper} from "./theme";

// Assuming each notification item has an id, title, description, and avatar URL
export function NotificationsItemsList({ notifications }) {
    return (
        <List sx={{ width: '100%', minWidth: 360, maxWidth: 360, maxHeight: 400,
            bgcolor: colorPaper
        }}>
            {notifications.map((notification, index) => (
                <React.Fragment key={notification.id}>
                    <ListItem alignItems="flex-start">
                        <ListItemAvatar>
                            <Avatar alt={notification.title} src={notification.avatar} />
                        </ListItemAvatar>
                        <ListItemText
                            primary={notification.title}
                            secondary={
                                <React.Fragment>
                                    {/*<div style={{margin: '10px'}}></div>*/}
                                    <Typography
                                        sx={{ display: 'inline'}}
                                        component="span"
                                        variant="body2"
                                        color="text.primary"
                                    >
                                        {notification.sender}
                                    </Typography>
                                    {` - ${notification.description}`}
                                </React.Fragment>
                            }
                        />
                    </ListItem>
                    {index < notifications.length - 1 && <Divider variant="inset" component="li" />}
                </React.Fragment>
            ))}
        </List>
    );
}